module.exports = __webpack_public_path__ + "img/joyful_ios_802.png";